<template>
  <v-card>
    <v-card-title class="align-start">
      <span>{{ $t('dashboard_student_subscriptions_title') }}</span>
      <v-spacer></v-spacer>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-data-table
        :headers="headers"
        :items="items"
        :items-per-page="10"
        item-key="payment_id"
        class="elevation-0"
        :footer-props="{
          'items-per-page-options': [5, 10, 25, 50],
        }"
      >
        <template #item.amount="{ item }">
          <span>{{ formatAmount(item.amount) }}</span>
        </template>
        <template #item.plan_price="{ item }">
          <span>{{ formatAmount(item.plan_price) }}</span>
        </template>
        <template #item.updated_at="{ item }">
          <span>{{ formatDate(item.updated_at) }}</span>
        </template>
        <template #item.transaction_id="{ item }">
          <span class="text-truncate d-inline-block" style="max-width: 140px" :title="item.transaction_id || ''">
            {{ item.transaction_id || '—' }}
          </span>
        </template>
        <template #no-data>
          <div class="py-8 text-center text--secondary">
            {{ $t('dashboard_student_subscriptions_empty') }}
          </div>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'DashboardStudentSubscriptions',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    headers() {
      return [
        { text: this.$t('dashboard_col_student'), value: 'student_name' },
        { text: this.$t('dashboard_col_school'), value: 'school_name' },
        { text: this.$t('dashboard_col_email'), value: 'student_email' },
        { text: this.$t('dashboard_col_amount'), value: 'amount', align: 'end' },
        { text: this.$t('dashboard_col_plan_price'), value: 'plan_price', align: 'end' },
        { text: this.$t('dashboard_col_status'), value: 'status' },
        { text: this.$t('dashboard_col_payment_method'), value: 'payment_method' },
        { text: this.$t('dashboard_col_transaction_id'), value: 'transaction_id' },
        { text: this.$t('dashboard_col_record_updated'), value: 'updated_at' },
      ]
    },
  },
  methods: {
    formatAmount(val) {
      if (val === null || val === undefined || val === '') {
        return '—'
      }
      const n = Number(val)
      if (Number.isNaN(n)) {
        return String(val)
      }
      return n.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })
    },
    formatDate(iso) {
      if (!iso) {
        return '—'
      }
      try {
        const d = new Date(iso)
        if (Number.isNaN(d.getTime())) {
          return '—'
        }
        return d.toLocaleString()
      } catch (e) {
        return '—'
      }
    },
  },
}
</script>
